import { Box, Divider, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import LinkConstants from "../../../../constants/LinkConstants";
import { useLogEvents } from "../../../../hooks/useLogEvents";
import BriaButton from "../../../common/BriaButton/BriaButton";
import styles from "./FigmaInstallSection.module.scss";

const FigmaInstallSection = () => {
	const { t } = useTranslation("translation", { keyPrefix: "figma.installSection" });
	const location = useLocation();
	const {
		logImageGenerationFigmaPluginDownloadClick,
		logImageEditingFigmaPluginDownloadClick,
		logTailoredGenerationFigmaPluginDownloadClick,
	} = useLogEvents();

	// Determine which context we're in based on the URL
	const isImageEditingTab = location.pathname.includes("image-editing");
	const isTailoredGenerationTab = location.pathname.includes("tailored-generation");

	const handleDownloadPlugin = () => {
		// Trigger appropriate analytics event based on context
		if (isImageEditingTab) {
			logImageEditingFigmaPluginDownloadClick();
		} else if (isTailoredGenerationTab) {
			logTailoredGenerationFigmaPluginDownloadClick();
		} else {
			logImageGenerationFigmaPluginDownloadClick();
		}

		window.open(LinkConstants.BRIA_FIGMA_PLUGIN, "_blank");
	};

	return (
		<Box className={styles.installContainer}>
			<Typography className={styles.title}>{t("title")}</Typography>

			{/* Install the plugin in Figma section */}
			<Box className={styles.card}>
				<Box className={styles.cardTextSection}>
					<Typography className={styles.cardTitle}>{t("installSection.title")}</Typography>
					<ol className={styles.stepsList}>
						<li>{t("installSection.step1")}</li>
						<li>{t("installSection.step2")}</li>
					</ol>
				</Box>
				<BriaButton buttonType="primaryMedium" onClick={handleDownloadPlugin} className={styles.actionButton}>
					{t("installSection.installButton")}
				</BriaButton>
			</Box>

			<Divider className={styles.divider} />

			{/* Start using section */}
			<Box className={styles.card}>
				<Box className={styles.cardTextSection}>
					<Typography className={styles.cardTitle}>{t("usageSection.title")}</Typography>
					<Typography className={styles.cardDescription}>{t("usageSection.description")}</Typography>
				</Box>
			</Box>
		</Box>
	);
};

export default observer(FigmaInstallSection);
